import React, { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { getToken, getManifest, getUserAgents } from 'store/Agents/actions';
import { selectToken, selectTokenExpiration, selectAgentError } from 'store/Agents/selectors';
import { selectAllowedByRole } from 'Hooks/usePermission/selector';
import { FEATURE_AGENT_TOKEN, PERMISSION_TYPES } from 'Hooks/usePermission/permissions';
import {
  Wrapper, Title, TextItem, Flex, SelectTitle, ContentWrapper, ErrorText
} from '../styled';
import { EnableText, DownloadTitle, LoadTitle } from './styled';
import { DockerTab, PythonTab } from './InfoTabs';
import Header from '../Header';
import Dispatcher from './dispatcher';

const SaveFinish = ({ prevStep, onClose }) => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const token = useSelector(selectToken);
  const expiresIn = useSelector(selectTokenExpiration);
  const canReadToken = useSelector((state) => selectAllowedByRole(state, FEATURE_AGENT_TOKEN, PERMISSION_TYPES.READ));
  const tokenFetchFailed = useSelector(selectAgentError);
  const hasTokenError = !canReadToken || tokenFetchFailed;

  useEffect(() => {
    if (canReadToken) {
      dispatch(getToken());
      dispatch(getManifest());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [canReadToken]);

  useEffect(() => {
    let timeOut = 0;
    if (expiresIn > 0) {
      timeOut = setTimeout(() => dispatch(getToken()), expiresIn * 1000);
    }
    return () => timeOut && clearTimeout(timeOut);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [expiresIn]);
  const [isDockerSelected, setIsDockerSelected] = useState(true);
  const onFinish = () => {
    onClose();
    dispatch(getUserAgents());
  };

  return (
    <Wrapper>
      <Header back={ prevStep } finish={ onFinish } />
      <ContentWrapper>
        <Title>{ intl.formatMessage({ id: 'agents.createAgent.saveFinish.title' }) }</Title>
        <EnableText>{ intl.formatMessage({ id: 'agents.createAgent.saveFinish.enable' }) }</EnableText>
        <DownloadTitle>{ intl.formatMessage({ id: 'agents.createAgent.saveFinish.download' }) }</DownloadTitle>
        <Dispatcher />
        <LoadTitle>{ intl.formatMessage({ id: 'agents.createAgent.saveFinish.load' }) }</LoadTitle>
        {hasTokenError
          ? <ErrorText>{ intl.formatMessage({ id: 'agents.createAgent.saveFinish.tokenError' }) }</ErrorText>
          : (
            <>
              <Flex>
                <SelectTitle selected={ isDockerSelected } onClick={ () => setIsDockerSelected(true) }>Docker</SelectTitle>
                <SelectTitle selected={ !isDockerSelected } onClick={ () => setIsDockerSelected(false) }>Python</SelectTitle>
              </Flex>
              {isDockerSelected ? <DockerTab token={ token } /> : <PythonTab token={ token } />}
            </>
            )}
        <TextItem>{ intl.formatMessage({ id: 'agents.createAgent.saveFinish.reload' }) }</TextItem>
      </ContentWrapper>
    </Wrapper>
  );
};

export default SaveFinish;
